var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.25 0H8.75C6.43021 0.00274266 4.20623 0.913523 2.56588 2.53256C0.925543 4.1516 0.00277875 6.3467 0 8.63636L0 29.3636C0.00277875 31.6533 0.925543 33.8484 2.56588 35.4674C4.20623 37.0865 6.43021 37.9973 8.75 38H33.25C35.5698 37.9973 37.7938 37.0865 39.4341 35.4674C41.0745 33.8484 41.9972 31.6533 42 29.3636V8.63636C41.9972 6.3467 41.0745 4.1516 39.4341 2.53256C37.7938 0.913523 35.5698 0.00274266 33.25 0ZM8.75 3.45455H33.25C34.2979 3.45658 35.3212 3.76807 36.1882 4.34893C37.0552 4.9298 37.7262 5.75345 38.115 6.71391L24.7135 19.9431C23.7273 20.9126 22.392 21.457 21 21.457C19.608 21.457 18.2727 20.9126 17.2865 19.9431L3.885 6.71391C4.27376 5.75345 4.94482 4.9298 5.81183 4.34893C6.67884 3.76807 7.70213 3.45658 8.75 3.45455ZM33.25 34.5455H8.75C7.35761 34.5455 6.02226 33.9995 5.03769 33.0277C4.05312 32.056 3.5 30.7379 3.5 29.3636V11.2273L14.812 22.3855C16.4546 24.0026 18.6799 24.9108 21 24.9108C23.3201 24.9108 25.5454 24.0026 27.188 22.3855L38.5 11.2273V29.3636C38.5 30.7379 37.9469 32.056 36.9623 33.0277C35.9777 33.9995 34.6424 34.5455 33.25 34.5455Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/Message.2bc12b52c0b7ca0ae86dd5e83b88c5ee.svg";
export { ForwardRef as ReactComponent };